/* 1:1 COPY DONT RIP — Maison Cosmetics compliance-review copy runtime (real-cart version, Oct 19, 2026).
   The old fake cart (fetch/XHR interception, mc11_cart localStorage, copy-checkout redirects) was removed:
   /cart/add.js, /cart.js, /cart and /checkout are the REAL Shopify endpoints now (Kaching Bundles + Kaching Cart). */
(function(){
  'use strict';
  window.Shopify = window.Shopify || {};
  if (!window.Shopify.loadFeatures) window.Shopify.loadFeatures = function(fs){ (fs||[]).forEach(function(f){ try { f.onLoad && f.onLoad(new Error('feature disabled in copy')); } catch(e){} }); };
  var S=window.Shopify; S.locale=S.locale||'en'; S.currency=S.currency||{active:'USD',rate:'1.0'}; S.country=S.country||'US'; S.routes=S.routes||{root:'/'}; S.cdnHost=S.cdnHost||'cdn.shopify.com';
  var M = window.MC11 || {};
  try { localStorage.removeItem('mc11_cart'); } catch(e){}  /* clear the retired fake cart */
  var PV = (function(){ var m = location.search.match(/preview_theme_id=(\d+)/); return m ? m[1] : (sessionStorage.getItem('mc11_pv') || ''); })();
  if (PV) sessionStorage.setItem('mc11_pv', PV);
  function link(u){ if(!u) return u; if (!/^\/(pages\/maison-|products\/)/.test(u) || !PV || /preview_theme_id=/.test(u)) return u; var h=''; var i=u.indexOf('#'); if(i>=0){h=u.slice(i);u=u.slice(0,i);} return u + (u.indexOf('?')>=0?'&':'?') + 'preview_theme_id=' + PV + h; }
  window.__mcLink = link;
  function go(u){ location.href = link(u); }
  M.go = go; M.link = link;
  function money(c){ return '$' + Math.round(c/100) + ' USD'; }
  function money2(c){ return '$' + (c/100).toFixed(2); }
  M.money=money; M.money2=money2;
  document.addEventListener('click', function(e){
    var a=e.target.closest && e.target.closest('a[href]'); if(!a) return;
    var h=a.getAttribute('href');
    if (h && /^\/(pages\/maison-|products\/)/.test(h) && PV && !/preview_theme_id/.test(h)) a.setAttribute('href', link(h));
  }, true);
  /* Non-cart forms (newsletter/contact/account) stay inert in the review copy; cart forms go to the real Shopify cart. */
  document.addEventListener('submit', function(e){
    var f=e.target; if (e.defaultPrevented) return;
    var act=f.getAttribute('action')||'';
    if (/\/cart(\/add)?(\.js)?\/?(\?|$)/.test(act) || /\/checkout/.test(act) || /\/search/.test(act)) return;
    e.preventDefault();
  }, false);
  M.ready=function(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); };
  window.MC11=M;
})();
